import * as THREE from 'three/build/three';
// Assign THREE to global variable
window.THREE = THREE;